import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQ } from "../lib/content";

export default function FaqSection() {
  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-[#F7F4F0] text-[#0A0A0A]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-[#B8965A]">
            <span className="block w-8 h-px bg-[#C9A86A]" />
            <span className="text-[11px] uppercase tracking-[0.3em]">Frequently Asked</span>
          </div>
          <h2 className="font-display-bold text-4xl md:text-5xl tracking-tight mt-6">
            Answers, <span className="font-serif-italic font-light text-[#B8965A]">honestly.</span>
          </h2>
          <p className="mt-6 text-[#525252] max-w-md leading-relaxed">
            A few of the questions our Sydney clients ask most. Don't see yours?
            Call us — we're happy to talk through any project, big or small.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-black/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-display-bold tracking-tight py-6 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[#525252] pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
